'use client';

import * as React from 'react';
import { motion } from 'framer-motion';
import { EASE_OUT } from '@/lib/motion';
import { usePrefersReducedMotion } from '@/shared/hooks/use-prefers-reduced-motion';

/**
 * Route-level enter transition (§2): a restrained fade + 8–12px rise, ~280ms.
 * Deliberately calm — the app's personality lives in micro-interactions, not
 * page wipes, and a heavy page animation would fight LiveKit's internal churn.
 * Reduced-motion users get an instant, static render.
 */
export function PageTransition({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const reduced = usePrefersReducedMotion();
  if (reduced) return <div className={className}>{children}</div>;

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.28, ease: EASE_OUT }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
